/* eslint-disable no-unused-vars */
import React, { useEffect, useState, Fragment, useRef } from 'react'
import './index.scss'
import qiyeweixinLogo from '@/assets/images/qiyeweixin.png'
import feishuLogo from '@/assets/images/feishuIcon.jpg'
import dingtalkLogo from '@/assets/images/dingtalk@3x.png'
import weixinLogo from '@/assets/images/WeiXin@3x.png'
import AgreementCheckbox from '../agreementCheckbox'
import { Input, message } from 'antd'
import SvgIcon from '@/components/svgIcon'
import {
  getWeComConfigV2, weComLoginV2, elcLoginApi,
  feishuLogin, getLarkConfig,
  dingtalkLoginGetEnterpriseConfig, dingtalkLogin,
} from '@/services/login'
import { THIRD_PARTY } from '@/config/default'
import dd from 'dingtalk-jsapi'
import { Origin, loginSuccess } from '@/utils/utils'
import intl from 'react-intl-universal'
import { useSearchParams } from 'react-router-dom'
import {
  weChatLoginGetEnterpriseList, weChatLogin, // 微信登录--查询已绑定企业/绑定/登录
} from '@/services/login'
import type { ThirdPartyLoginConfig } from '@/services/login/types'
import { useLoginStore } from '@/store/loginStore'
import { CLIENT_TYPE, authType } from '@/config/default'
import * as ww from '@wecom/jssdk'

export default function ThirdPartyLogin({
  agreementRef,
  agreementChecked,
  setAgreementChecked
}: {
  agreementRef: React.RefObject<any>
  agreementChecked: boolean
  setAgreementChecked: (checked: boolean) => void
}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const { setThirdInfo, setShowBindAccount, setShowSelectAccount, setSelectAccounts, setShowAddInfo } = useLoginStore()

  const [redirectUri] = useState(encodeURIComponent(`${Origin()}/login`))
  const [activeType, setActiveType] = useState('') // 当前激活显示输入框的类型
  const [enterpriseCode, setEnterpriseCode] = useState('') // 企业号
  const [enterpriseConfig, setEnterpriseConfig] = useState<ThirdPartyLoginConfig | null>(null) // 企业配置

  const thirdPartyState = searchParams.get('state')
  const enterpriseCodeUrl = thirdPartyState?.split('@')?.[1] || searchParams.get('enterpriseCode') || ''
  const authCode = searchParams.get('code') || ''

  
  const ErrorType = {
    ENTERPRISE_NOT_BIND: intl.get('login.enterpriseNotBind'),
    ENTERPRISE_CANCELLED_BIND: intl.get('login.enterpriseCancelledBind'),
    USER_NOT_EXIST: intl.get('login.userNotExist'),
    SYSTEM_ERROR: intl.get('login.systemError'),
    USER_NOT_BIND: intl.get('login.userNotBind'),
    DING_TALK_USER_NOT_EXIST: intl.get('login.dingtalkUserNotExist'),
    PLATFORM_DISABLED: intl.get('login.platformDisabled'),
  }

  const otherLoginList = [
    { name: intl.get('login.weixin'), img: weixinLogo, value: THIRD_PARTY.WECHAT },
    { name: intl.get('login.qiyeweixin'), img: qiyeweixinLogo, value: THIRD_PARTY.WECOM },
    { name: intl.get('login.feishu'), img: feishuLogo, value: THIRD_PARTY.LARK },
    { name: intl.get('login.dingtalk'), img: dingtalkLogo, value: THIRD_PARTY.DINGTALK }
  ]


  // 飞书登录
  const feishuLoginApi = async () => {
    // appId = 'cli_a5e327ec6178100c' // 泡泡马特
    const loginApi = async (code, authType) => {
      try {
        const res = await feishuLogin({
          authCode: code,
          enterpriseCode: enterpriseCodeUrl,
          authType,
        })
        if (res && res.status) {
          loginSuccess(res.loginResponse)
        } else {
          if (res.errorType === 'USER_NOT_BIND') {
            setShowBindAccount(true)
            setThirdInfo({
              type: THIRD_PARTY.LARK,
              feishuUserId: res.feishuUserId,
              feishuUserName: res.feishuUserName,
              authType,
            })
          }
          // setSearchParams({})
          // message.error(ErrorType[res.errorType])
        }
      } catch (error) {
        setSearchParams({})
        console.log(error)
      }
    }
    if (window.h5sdk) {
      // 飞书应用内免密登录
      window.h5sdk.ready(() => {
        const appId = searchParams.get('appId')
        window.tt.requestAuthCode({
          appId,
          success: (info) => {
            console.log('feishu sucess', info.code)
            loginApi(info.code, authType.SSO)
          },
          fail: (error) => {
            message.error(error)
          }
        })
      })
    } else {
      loginApi(authCode, authType.SCAN_CODE)
    }
  }

  // 个人微信登录(个人微信可能存在绑定多个账号,故先查询已绑定企业,如未绑定则提示绑定企业,如已绑定,只有一个则直接登录,多个则提示选择账号)
  const weChatLoginApi = async () => {
    try {
      const code = searchParams.get('code')
      const res = await weChatLoginGetEnterpriseList({
        authCode: code,
        clientType: CLIENT_TYPE.PC
      })
      setThirdInfo({
        unionId: res.unionId,
        openId: res.openId,
        type: THIRD_PARTY.WECHAT,
        authType: authType.SCAN_CODE,
      })
      if (!res?.enterprises?.length) {
        // 未绑定,跳转至绑定页面
        setShowBindAccount(true)
      } else if (res?.enterprises?.length === 1) {
        // 仅绑定一个账号,直接登录
        const data = await weChatLogin({
          openId: res.openId,
          unionId: res.unionId,
          enterpriseCode: res.enterprises[0].enterpriseCode,
          clientType: CLIENT_TYPE.PC,
          account: res.enterprises[0].account,
          authType: authType.SCAN_CODE,
        })
        if (data.status) {
          loginSuccess(data.loginResponse)
        }
      } else {
        // 多个账号,提示选择账号
        setShowSelectAccount(true)
        setSelectAccounts(res.enterprises || [])
      }
    } catch (error) {
      // 查询已绑定企业失败,提示用户重新登录
      setSearchParams({})
    }
  }

  // 钉钉登录
  const dingtalkLoginApi = async () => {
    if (!enterpriseCodeUrl) return
    const loginApi = async (code, authType) => {
      try {
        const res = await dingtalkLogin({
          authCode: code,
          clientType: CLIENT_TYPE.PC,
          enterpriseCode: enterpriseCodeUrl,
          authType
        })
        if (res && res.status) {
          loginSuccess(res.loginResponse)
        } else {
          if (res.errorType === 'USER_NOT_BIND') {
            setThirdInfo({
              type: THIRD_PARTY.DINGTALK,
              dingTalkUserId: res.dingTalkUserId,
              authType
            })
            setShowBindAccount(true)
          }
        }
        console.log('dingtalk config', res)
      } catch (error) {
        setSearchParams({})
        console.log(error)
      }
    }
    if (dd.env.platform !== 'notInDingTalk') {
      // 钉钉应用内免密登录
      dd.ready(async () => {
        const config = await getEnterpriseConfig(THIRD_PARTY.DINGTALK, enterpriseCodeUrl)
        if (!config || config.type !== THIRD_PARTY.DINGTALK) {
          message.error(intl.get('login.enterpriseNotBind'))
          return
        }
        const corpId = searchParams.get('corpId')
        dd.requestAuthCode({
          corpId,
          clientId: config.data.clientId,
          onSuccess: res => {
            console.log('钉钉获取code成功', res)
            loginApi(res.code, authType.SSO)
          },
          onFail: err => console.error('获取code失败', err)
        })
      })
    } else {
      // 网页授权后登录
      loginApi(authCode, authType.SCAN_CODE)
    }
  }

  // 企微登录
  const weComLoginApi = async () => {
    // 企微应用内免密登录, 需要企微服务商配置桌面应用url(配置Oauth回调地址，此接口需要付费)，回调成功后与网页授权后流程一致
    if (!enterpriseCodeUrl) return
    const config = await getEnterpriseConfig(THIRD_PARTY.WECOM, enterpriseCodeUrl)
    if (!config || config.type !== THIRD_PARTY.WECOM) return
    try {
      if (enterpriseCodeUrl.toLowerCase() === 'elc' || enterpriseCodeUrl.toLowerCase() === 'elc1') {
        // 需要区分elc定制企微登录
        const res = await elcLoginApi({
          authCode: authCode,
          corpId: config.data.corpId,
          authType: ww.env.isWeCom ? authType.SSO : authType.SCAN_CODE,
        })
        if (res && res.status) {
          loginSuccess(res.loginResponse)
        } else {
          message.error(intl.get('login.loginFailed'))
        }
      } else {
        // 非elc定制企微登录
        const res = await weComLoginV2({
          authCode: authCode,
          corpId: config.data.corpId,
          authType: ww.env.isWeCom ? authType.SSO : authType.SCAN_CODE,
        })
        if (res && res.status) {
          loginSuccess(res.loginResponse)
        } else {
          if (res.errorType === 'USER_NOT_BIND') {
            setThirdInfo({
              type: THIRD_PARTY.WECOM,
              corpId: config.data.corpId,
              qwUserId: res.qwUserId,
              authType: ww.env.isWeCom ? authType.SSO : authType.SCAN_CODE,
            })
            setShowBindAccount(true)
          }
        }
      }
    } catch (error) {
      setSearchParams({})
    }
  }

  // 执行自动登录
  const autoLogin = async () => {
    // 判断当前是哪个第三方平台返回的
    if (!thirdPartyState) return
    if (thirdPartyState?.indexOf(THIRD_PARTY.DINGTALK) !== -1) {
      dingtalkLoginApi()
    } else if (thirdPartyState.indexOf(THIRD_PARTY.LARK) !== -1) {
      feishuLoginApi()
    } else if (thirdPartyState.indexOf(THIRD_PARTY.WECOM) !== -1) {
      weComLoginApi()
    } else if (thirdPartyState.indexOf(THIRD_PARTY.WECHAT) !== -1) {
      weChatLoginApi()
    }
  }
  // 免输企业号自动跳转第三方授权登录流程
  const checkThirdAutoLogin = async () => {
    const isThirdAutoLogin = searchParams.get('isThirdAutoLogin')
    const enterpriseCode = searchParams.get('enterpriseCode')
    const platform = searchParams.get('platform')
    if (isThirdAutoLogin === 'true' && enterpriseCode && platform) {
      const config = await getEnterpriseConfig(platform, enterpriseCode)
      if (config) {
        handleThirdLogin(platform, config)
      }
    }
  }

  useEffect(() => {
    autoLogin()
    checkThirdAutoLogin()
  }, [])

  // 选择第三方平台
  const setActiveLoginType = (item) => {
    setEnterpriseCode('')
    switch (item.value) {
      case THIRD_PARTY.WECHAT:
        setActiveType('')
        handleThirdLogin(item.value)
        break
      case THIRD_PARTY.WECOM:
      case THIRD_PARTY.LARK:
      case THIRD_PARTY.DINGTALK:
        setActiveType(item.value)
        break
      default:
        setActiveType('')
        break
    }
  }

  // 获取企业配置
  const getEnterpriseConfig = (type, code?): Promise<ThirdPartyLoginConfig | null> => {
    return new Promise<ThirdPartyLoginConfig | null>(async (resolve, reject) => {
      let config: ThirdPartyLoginConfig | null = null
      const checkType = type || activeType
      switch (checkType) {
        case THIRD_PARTY.WECOM:
          if (!(code || enterpriseCode)) {
            reject(false)
            return
          }
          const wecomConfig = await getWeComConfigV2({
            enterpriseCode: code || enterpriseCode
          })
          if (wecomConfig.corpId && wecomConfig.agentId) {
            config = { type: THIRD_PARTY.WECOM, data: wecomConfig }
          }
          break
        case THIRD_PARTY.LARK:
          // cli_a5a9d4b0aefc100b 云盯qa
          // cli_a5d1af05ee6e100c 云盯线上
          // cli_aaabf1dfd73a9cc0 lrf测试
          // cli_a5e327ec6178100c 泡泡马特
          const larkConfig = await getLarkConfig({
            enterpriseCode: code || enterpriseCode
          })
          if (larkConfig.appId) {
            config = { type: THIRD_PARTY.LARK, data: larkConfig }
          }
          break
        case THIRD_PARTY.DINGTALK:
          const dingtalkConfig = await dingtalkLoginGetEnterpriseConfig({
            enterpriseCode: code || enterpriseCode
          })
          if (dingtalkConfig.clientId) {
            config = { type: THIRD_PARTY.DINGTALK, data: dingtalkConfig }
          }
          break
        default:
          break
      }
      setEnterpriseConfig(config)
      resolve(config)
    })
  }

  // 获取第三方企业应用配置 并执行登录
  const getThirdPartyConfig = async (item) => {
    const config = await getEnterpriseConfig(item.value)
    if (config) {
      handleThirdLogin(activeType, config)
    }
  }

  // 点击第三方平台登录
  const handleThirdLogin = (type, enterpriseConfig?): {
    type: string,
    enterpriseConfig?: ThirdPartyLoginConfig
  } => {
    const thirdLogin = () => {
      switch (type) {
        case THIRD_PARTY.WECHAT:
          // 微信 QA appId: wxd9484f853d14bacc  线上 appId: wx2d967ddeab0345eb
          window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx2d967ddeab0345eb&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login&state=wechat#wechat_redirect`
          break
        case THIRD_PARTY.WECOM:
          window.location.href = `https://login.work.weixin.qq.com/wwlogin/sso/login?login_type=CorpApp&appid=${enterpriseConfig.data.corpId}&agentid=${enterpriseConfig.data.agentId}&redirect_uri=${redirectUri}&state=wecom@${enterpriseCode || enterpriseCodeUrl}`
          break
        case THIRD_PARTY.LARK:
          window.location.href = `https://open.feishu.cn/open-apis/authen/v1/authorize?app_id=${enterpriseConfig.data.appId}&redirect_uri=${redirectUri}&state=lark@${enterpriseCode || enterpriseCodeUrl}`
          break
        case THIRD_PARTY.DINGTALK:
          window.location.href = `https://login.dingtalk.com/oauth2/auth?redirect_uri=${redirectUri}&response_type=code&client_id=${enterpriseConfig.data.clientId}&scope=openid corpid&state=dingtalk@${enterpriseCode || enterpriseCodeUrl}&prompt=consent`
          break
        default:
          break
      }
    }
    // 未勾选协议，点击登录按钮弹窗协议确认
    if (!agreementChecked) {
      agreementRef.current && agreementRef.current.showAgreementModal(() => {
        thirdLogin()
      })
      return
    }
    // 获取企业配置
    thirdLogin()
  }

  return (
    <div className='loginForm-third'>
      <Fragment>
        <div className='loginForm-third-title'>
          {intl.get('login.selectThirdPartyLogin')}
        </div>
        <div className='loginForm-third-desc'>
          {intl.get('login.clickIconToAuthorize')}
        </div>
        {otherLoginList.map((item) => {
          const isActive = activeType === item.value
          return (
            <div className='loginForm-third-row' key={item.name}>
              <Input
                value={enterpriseCode}
                onChange={(e) => setEnterpriseCode(e.target.value.trim())}
                className={`loginForm-third-input ${isActive ? 'loginForm-third-active' : ''}`}
                placeholder={intl.get('login.pleaseEnterEnterpriseCodeToGetApp', { name: item.name })}
                prefix={<SvgIcon name='logoEnterprise' />}
                suffix={<div className='loginForm-third-suffix' onClick={() => getThirdPartyConfig(item)}>
                  {intl.get('login.getApp')}
                </div>}
              />
              <div
                className={`loginForm-third-item ${isActive ? 'loginForm-third-hidden' : ''}`}
                onClick={() => setActiveLoginType(item)}
              >
                {/* 图标和文字，激活时隐藏 */}
                <div className={`loginForm-third-item-content`}>
                  <img src={item.img} alt={item.name} />
                  <div>{item.name}</div>
                </div>

              </div>
            </div>
          )
        })}
        <AgreementCheckbox
          ref={agreementRef}
          checked={agreementChecked}
          onChange={setAgreementChecked}
        />
      </Fragment>
    </div>
  )
}
